import * as React from "react";
import { Button } from "semantic-ui-react";

interface Props {
    customerId: string;
    employeeRecordId: string;
    ohCaseId: string;
}

export const ViewEmployeeCaseButton: React.FunctionComponent<Props> = (props: Props) => {
    if (props.customerId && props.employeeRecordId && props.ohCaseId) {
        return (
            <a
                href={`/customers/${props.customerId}/employeeRecords/${props.employeeRecordId}/ohCases/${props.ohCaseId}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                <Button secondary type="button" content="View Employee Case" />
            </a>
        );
    }
    return null;
};
